module.exports = __webpack_public_path__ + "img/9-en.e8ac1918.png";